/** 门户 53 客服独立小窗（复用同一窗口名，避免连开多个） */
export const CUSTOMER_SERVICE_URL =
  'https://www5c1.53kf.com/webCompany.php?kf_sign=zQyODMTc4McxMDE3MTAyNDE4NTk4MDAyNzIxMTEzOTc=&arg=10111397&style=1&guest_id=16384707687002&language=zh-cn&charset=gbk&referer=https%3A%2F%2Fzjssoft.com%2F&keyword=&tpl=crystal_blue&uid=3ee7df78258c4a322808247e0a6136bd&is_group=&tfrom=1&timeStamp=1783428712012&ucust_id='

const POPUP_NAME = 'zjs_customer_service'
const POPUP_WIDTH = 960
const POPUP_HEIGHT = 720

export function openCustomerService() {
  const left = Math.max(0, Math.round((window.screen.availWidth - POPUP_WIDTH) / 2))
  const top = Math.max(0, Math.round((window.screen.availHeight - POPUP_HEIGHT) / 2))
  const features = [
    'popup=yes',
    `width=${POPUP_WIDTH}`,
    `height=${POPUP_HEIGHT}`,
    `left=${left}`,
    `top=${top}`,
    'scrollbars=yes',
    'resizable=yes'
  ].join(',')
  const win = window.open(CUSTOMER_SERVICE_URL, POPUP_NAME, features)
  win?.focus()
  return win
}
